import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da13e1b6&scoped=true&"
import script from "./CategoriesModal.js?vue&type=script&lang=js&"
export * from "./CategoriesModal.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=da13e1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da13e1b6",
  null
  
)

export default component.exports